var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateNotifications({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 104,
    viewBox: "0 0 118 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9011 75.89C16.4424 75.89 16.8811 75.4512 16.8811 74.91C16.8811 74.3688 16.4424 73.93 15.9011 73.93C15.3599 73.93 14.9211 74.3688 14.9211 74.91C14.9211 75.4512 15.3599 75.89 15.9011 75.89Z",
    fill: "#CFCFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4512 34.93C71.0812 34.93 62.5612 34.59 54.5912 32.37C46.7712 30.2 39.5912 25.99 33.1912 21.12C29.0012 17.95 25.1912 15.42 19.7512 15.8C14.4293 16.088 9.34 18.0753 5.23121 21.47C-1.68879 27.53 -0.648793 38.76 2.12121 46.62C6.28121 58.49 18.9412 66.76 29.7012 72.11C42.1312 78.32 55.7912 81.93 69.4812 84C81.4812 85.83 96.9012 87.15 107.301 79.32C116.851 72.11 119.471 55.67 117.131 44.57C116.563 41.2909 114.817 38.3321 112.221 36.25C105.511 31.34 95.5012 34.62 87.9612 34.78C85.1612 34.84 82.3112 34.91 79.4512 34.93Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0212 85.24C68.2565 85.24 73.3112 80.1853 73.3112 73.95C73.3112 67.7147 68.2565 62.66 62.0212 62.66C55.7859 62.66 50.7312 67.7147 50.7312 73.95C50.7312 80.1853 55.7859 85.24 62.0212 85.24Z",
    fill: "#D2D2D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3548 3.46615C50.979 3.32697 51.6246 3.31209 52.2545 3.42238C52.8845 3.53266 53.4865 3.76595 54.0263 4.10891C54.5661 4.45188 55.0331 4.8978 55.4006 5.42123C55.768 5.94466 56.0288 6.53535 56.168 7.15955L57.9721 15.2509L48.4461 17.3749L46.6419 9.28365C46.5024 8.65779 46.4878 8.01054 46.599 7.37903C46.7102 6.74753 46.945 6.14421 47.29 5.60369C47.635 5.06317 48.0833 4.5961 48.6093 4.22929C49.1352 3.86247 49.7284 3.60313 50.3548 3.46615Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8614 66.94L36.9714 79.84C36.6118 79.9207 36.2374 79.9062 35.8851 79.7981C35.5328 79.69 35.2148 79.4919 34.9624 79.2233C34.71 78.9548 34.532 78.6251 34.4459 78.2668C34.3598 77.9085 34.3686 77.5339 34.4714 77.18L34.7114 76.35C36.7114 69.26 38.4514 61.45 36.8514 54.25L33.4314 38.89C30.5514 25.98 38.2914 12.83 51.1314 9.66C54.2624 8.88273 57.5172 8.73959 60.7043 9.239C63.8915 9.73841 66.9465 10.8703 69.6897 12.568C72.4329 14.2657 74.8088 16.495 76.6775 19.1246C78.5463 21.7542 79.8702 24.7311 80.5714 27.88L84.1014 43.76C85.7114 50.96 90.5714 57.32 95.4314 62.86L96.0014 63.51C96.2321 63.7884 96.3883 64.1209 96.455 64.4762C96.5218 64.8316 96.4969 65.1981 96.3829 65.5412C96.2689 65.8844 96.0693 66.1928 95.8032 66.4375C95.537 66.6822 95.2129 66.8552 94.8614 66.94Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3614 1.96C74.9026 1.96 75.3414 1.52124 75.3414 0.98C75.3414 0.43876 74.9026 0 74.3614 0C73.8201 0 73.3813 0.43876 73.3813 0.98C73.3813 1.52124 73.8201 1.96 74.3614 1.96Z",
    fill: "#CFCFCF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9011 75.89C16.4424 75.89 16.8811 75.4512 16.8811 74.91C16.8811 74.3688 16.4424 73.93 15.9011 73.93C15.3599 73.93 14.9211 74.3688 14.9211 74.91C14.9211 75.4512 15.3599 75.89 15.9011 75.89Z",
    fill: "#CFCFCF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.441 24.65V28.95",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2913 26.8H103.591",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M103.401 89.39V93.69",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M101.251 91.54H105.551",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2212 8.35004V12.65",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0713 10.5H30.3713",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3714 103.46C79.6458 103.46 96.0814 102.435 96.0814 101.17C96.0814 99.9053 79.6458 98.88 59.3714 98.88C39.097 98.88 22.6614 99.9053 22.6614 101.17C22.6614 102.435 39.097 103.46 59.3714 103.46Z",
    fill: "#F2F2F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4412 22.21C94.4386 25.2512 93.2293 28.1671 91.0788 30.3176C88.9283 32.4681 86.0124 33.6774 82.9712 33.68C82.5971 33.68 82.2232 33.6599 81.8512 33.62L78.4512 39.17L77.3912 32.22C75.6247 31.2364 74.1496 29.8033 73.1154 28.066C72.0812 26.3287 71.5246 24.3489 71.5019 22.3271C71.4793 20.3054 71.9915 18.3136 72.9866 16.5536C73.9817 14.7936 75.4244 13.3279 77.1684 12.305C78.9124 11.2821 80.8958 10.7384 82.9176 10.7289C84.9395 10.7195 86.9279 11.2447 88.6814 12.2512C90.4349 13.2578 91.8912 14.7099 92.9027 16.4606C93.9142 18.2112 94.4449 20.1982 94.4412 22.22V22.21Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0714 23.37C78.712 23.37 79.2314 22.8506 79.2314 22.21C79.2314 21.5693 78.712 21.05 78.0714 21.05C77.4307 21.05 76.9114 21.5693 76.9114 22.21C76.9114 22.8506 77.4307 23.37 78.0714 23.37Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9713 23.37C83.6119 23.37 84.1313 22.8506 84.1313 22.21C84.1313 21.5693 83.6119 21.05 82.9713 21.05C82.3306 21.05 81.8113 21.5693 81.8113 22.21C81.8113 22.8506 82.3306 23.37 82.9713 23.37Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8712 23.37C88.5118 23.37 89.0312 22.8506 89.0312 22.21C89.0312 21.5693 88.5118 21.05 87.8712 21.05C87.2305 21.05 86.7112 21.5693 86.7112 22.21C86.7112 22.8506 87.2305 23.37 87.8712 23.37Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateNotifications);
export default __webpack_public_path__ + "static/media/empty-state-notifications.41cdbf8b1c793dd1bdae0902cab9a7ce.svg";
export { ForwardRef as ReactComponent };